import React, { FC, useState, useEffect } from "react";
import { TableRowInput } from "../Common";
import { LocaleSettings as Model } from "../../store/OJEUStore/models";

export interface LocaleSettingsProps {
    localeSettings: Model,
    saveLocaleSettings: (newLocaleSettings: Model) => void
}

export const LocaleSettings: FC<LocaleSettingsProps> = (props) => {
    const [localeSettings, setLocaleSettings] = useState(props.localeSettings);

    const save = () => props.saveLocaleSettings(localeSettings);
    useEffect(() => {
        setLocaleSettings(props.localeSettings);
    }, [props.localeSettings]);

    return (
        <table className="table table-sm mb-1">
            <tbody>
                <TableRowInput
                    name="Language"
                    currentValue={localeSettings.language}
                    originalValue={props.localeSettings.language}
                    inputType="text"
                    onSave={save}
                    onChange={newValue => setLocaleSettings({ ...localeSettings, language: String(newValue) })} />
            </tbody>
        </table>
    );
};
